import { render, staticRenderFns } from "./CreateFestival.vue?vue&type=template&id=704d2d64"
import script from "./CreateFestival.vue?vue&type=script&lang=js"
export * from "./CreateFestival.vue?vue&type=script&lang=js"
import style0 from "./CreateFestival.vue?vue&type=style&index=0&id=704d2d64&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704d2d64')) {
      api.createRecord('704d2d64', component.options)
    } else {
      api.reload('704d2d64', component.options)
    }
    module.hot.accept("./CreateFestival.vue?vue&type=template&id=704d2d64", function () {
      api.rerender('704d2d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CreateFestival.vue"
export default component.exports